import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { isEmailChannel } from "../../channels/types";
import { getTargetType } from "../../to/to-target";
import { getMomentEditStatus } from "./use-moment-edit-status";

import type { UseMomentProperties } from "../../moment-card/types";
import type { MomentFormMoment } from "../types/moment-form-moment";

export function useNewsletterRedirect(moment: MomentFormMoment, newsletter?: boolean): void {
  const navigate = useNavigate();
  const { search } = useLocation();

  const status = getMomentEditStatus(moment);

  useEffect(() => {
    if (status === "new") return;

    const shouldUseNewsletter = isNewsletter(moment);

    if (newsletter && !shouldUseNewsletter) {
      void navigate({ pathname: `/moments/${moment.id}`, search }, { replace: true });
    } else if (!newsletter && shouldUseNewsletter) {
      void navigate({ pathname: `/moments/${moment.id}/newsletter`, search }, { replace: true });
    }
  }, [moment, navigate, newsletter, search, status]);
}

export function isNewsletter(
  moment: Pick<
    UseMomentProperties,
    | "use_lexical_editor"
    | "channel"
    | "only_additional_recipients"
    | "target_manager"
    | "target_connection_type"
    | "target_channel"
    | "notify_channel"
  >,
): boolean {
  const { toTarget } = getTargetType(moment);

  return (
    !moment.use_lexical_editor &&
    (!moment.channel || isEmailChannel(moment.channel)) &&
    toTarget === "employee"
  );
}
